/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation RelaisSelfcareSouscriptionPricingMutation {
    relaisSelfcareSouscriptionPricing_M_souscription_pricing {
      ok
      error
      
    }
  }
`;

export default mutation;
